"use client"
"use client";
import {
  select_default
} from "../chunk-LE5GK4E6.js";
import {
  getPropByString
} from "../chunk-Q2O3JHTB.js";

// src/select/select-field.tsx
import {
  Controller,
  useFormContext,
  useFormState
} from "react-hook-form";
import { jsx } from "react/jsx-runtime";
var SelectField = (props) => {
  const { control, getValues } = useFormContext();
  const { errors } = useFormState();
  const error = getPropByString(errors, props.name);
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name: props.name,
      disabled: props.disabled,
      rules: props.rules,
      defaultValue: props.initialValue,
      control,
      render: ({ field: { onChange, value, ref } }) => /* @__PURE__ */ jsx(
        select_default,
        {
          ...props,
          onChange,
          ref,
          initialValue: getValues(props.name),
          selectedOption: value,
          error: error?.message
        }
      )
    }
  );
};
var select_field_default = SelectField;
export {
  select_field_default as default
};
